import { FormGroup } from '@angular/forms';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { ApiResponse } from '@core/models/api-response.model';
import { Store, select } from '@ngrx/store';
import { AppState } from '@store/reducers';
import { map } from 'rxjs/operators';
import { AesService } from '@core/services/aes.service';


@Injectable()
export class AuthHttpService {
    navigations$ = new Subject<any[]>();

    constructor(
      private http: HttpClient,
      private store: Store<AppState>,
      private aesService: AesService,
    ) {}

    login(merchant_code: string, username: string, rawPassword: string) {
      // encrypt the raw password before sending to api
      const password = this.aesService.encryptWithReqSignKey(rawPassword);
      return this.http.post<ApiResponse>('/login', {merchant_code, username, password});
    }

    logout() {
      return this.http.get('/logout');
    }

    getNavigations() {
      return this.http.get('/navigation');
    }

    changePassword(password: { password: string, password_confirmation: string }) {
      // encrypt the raw password before sending to api
      password.password = this.aesService.encryptWithReqSignKey(password.password);
      password.password_confirmation = this.aesService.encryptWithReqSignKey(password.password_confirmation);
      return this.http.post<ApiResponse>('/changepassword', password );
    }

    resetPassword(password: { password: string, password_confirmation: string, username: string }) {
      // encrypt the raw password before sending to api
      password.password = this.aesService.encryptWithReqSignKey(password.password);
      password.password_confirmation = this.aesService.encryptWithReqSignKey(password.password_confirmation);
      return this.http.post<ApiResponse>('/resetpassword', password );
    }

    forceLowerCaseInputControl(formGroup: FormGroup, formControlName: string, event: Event) {
      formGroup.get(formControlName).setValue((event.target as HTMLInputElement).value.toLowerCase());
    }

    changeTimezone(timezone: {timezone: string}) {
      return this.http.put<ApiResponse>('/timezoneupdate', timezone);
    }

}
